/**
 * Stories for DashboardPageLayout handle this component
 */
/* eslint-disable local-rules/require-storybook-documentation */
import '@zillow/constellation-fonts/zillow-fonts.css';

import { memo } from 'react';
import { Box } from '@zillow/constellation-10';
import { CLS_MITIGATION_SETTINGS } from 'src/common/styles/constants';
import { FunctionComponentWithChildren } from 'src/utils/types';

import { pageLayoutStyles } from './styles/PageLayout.styles';

export const PageLayout: FunctionComponentWithChildren<{ maxWidth?: string }> = ({ children, maxWidth }) => (
    <Box className={pageLayoutStyles()} style={{ maxWidth: maxWidth || CLS_MITIGATION_SETTINGS.MAC_WIDTH_OF_CONTENT }}>
        {children}
    </Box>
);

export const PageWithHeroImageLayout: FunctionComponentWithChildren<{ maxWidth?: string }> = memo(
    ({ children, maxWidth }) => (
        <Box
            className={pageLayoutStyles()}
            style={{ maxWidth: maxWidth || CLS_MITIGATION_SETTINGS.MAC_WIDTH_OF_CONTENT }}>
            {children}
        </Box>
    )
);
